
// https://docs.mapbox.com/mapbox-gl-js/api/map/#map#addcontrol
export const AddControlPositionEnumType = {
  name: "enum",
  enums: [
    {
      value: "top-left",
      label: "Top Left",
    },
    {
      value: "top-right",
      label: "Top Right",
    },
    {
      value: "bottom-left",
      label: "Bottom Left",
    },
    {
      value: "bottom-right",
      label: "Bottom Right",
    },
  ]
}
